import React, { ReactNode } from 'react'

import { SxProps, ThemeProvider } from '@mui/material'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Collapse from 'components_new/atoms/Collapse'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'

import { getTheme } from 'themes'

interface EditModeBarProps {
  actions?: ReactNode
  open?: boolean
  sx?: SxProps
}

const EditModeBar = (props: EditModeBarProps) => {
  const { actions, open, sx } = props

  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <Collapse in={open}>
        <ThemeProvider theme={getTheme('dark')}>
          <Box
            sx={{
              bgcolor: 'background.default',
              py: 0.5,
              pl: 2,
              pr: 4,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              ...sx
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title={t('dashboards', 'editing_mode_limitations')}>
                <Icon
                  color="primary"
                  name="Info"
                  fontSize="small"
                  sx={{ mr: 1 }}
                />
              </Tooltip>
              <Text color="text.primary" variant="body2">
                {t('dashboards', 'editing_mode_active')}{' '}
                {/* @TODO: Make general */}
              </Text>
            </Box>
            {actions}
          </Box>
        </ThemeProvider>
      </Collapse>
    </Box>
  )
}

export default EditModeBar
